import React from 'react';
import { FC } from 'react';
// import useTranslate from 'shared/hooks/useTranslate';

import "./WhatsappStickyBtn.scss";
import WhatsappIcon from './WhatsappIcon';

const PHONE_NUMBER = "628119539396"
const WA_TEXT = `https://wa.me/${PHONE_NUMBER}/?text=Saya%20ingin%20tahu%20lebih%20banyak%20tentang%20Direktori%20Kampus%20by%20Portal%20Sekolah.%20Berikut%20ini%20detail%20saya%3A%0ANama%3A%20%0AJabatan%3A%20%0APerusahaan%3A%20%0ANomor%20kontak%3A%20%0AEmail%3A%20%0APesan%2FPertanyaan%3A`;

interface IProps {
    text: string;
}

const WhatsappStickyBtn: FC<IProps> = ({
    text
}) => {
    const handleWaLink = () => {
        window.open(WA_TEXT, "_blank");
    }

    return (
        <div className='whatsapp-sticky-wrapper'>
            <div className='whatsapp-sticky-btn' onClick={handleWaLink}>
                <WhatsappIcon width="50" height="80" />
                <div className='hover-text'>{text}</div>
            </div>
        </div>
    );
}

export default WhatsappStickyBtn;
